"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteCardAction = exports.DeleteCardCommand = exports.DeleteCardCommands = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../..");
const Command_1 = require("./Command");
var DeleteCardCommands;
(function (DeleteCardCommands) {
    DeleteCardCommands["Delete"] = "card/delete";
})(DeleteCardCommands = exports.DeleteCardCommands || (exports.DeleteCardCommands = {}));
function DeleteCardCommand(options) {
    const data = Object.assign({ command: DeleteCardCommands.Delete }, options);
    return new Command_1.Command(data);
}
exports.DeleteCardCommand = DeleteCardCommand;
const DeleteCardAction = (messageId) => {
    return __1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: "Dismiss message",
        data: DeleteCardCommand({ messageId }).toInvokeCommand(),
    });
};
exports.DeleteCardAction = DeleteCardAction;
//# sourceMappingURL=DeleteCardCommand.js.map